import { render } from "./MainLayout.vue?vue&type=template&id=55a2a82c"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=55a2a82c&lang=scss"

import exportComponent from "/Users/wang/work/soulex/nebula-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__